// import React, { useState, useEffect, useRef } from 'react';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import {
//   getVersions,
//   createVersion,
//   updateVersion,
//   deleteVersion,
//   toggleVersionStatus,
//   getVersionStats
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/VersionManagement.css';

// const appTypes = [
//   { id: 'user', label: 'User App', icon: '👤', color: '#4F46E5', bgColor: '#EEF2FF' },
//   { id: 'partner', label: 'Partner App', icon: '🤝', color: '#059669', bgColor: '#ECFDF5' },
//   { id: 'executive', label: 'Executive App', icon: '💼', color: '#D97706', bgColor: '#FFFBEB' },
//   { id: 'crm', label: 'CRM App', icon: '📊', color: '#DC2626', bgColor: '#FEF2F2' }
// ];

// const platformOptions = [
//   { value: 'all', label: 'All Platforms' },
//   { value: 'ios', label: 'iOS' },
//   { value: 'android', label: 'Android' },
//   { value: 'web', label: 'Web' }
// ];

// const releaseTypeOptions = [
//   { value: 'major', label: 'Major', color: '#DC2626' },
//   { value: 'minor', label: 'Minor', color: '#D97706' },
//   { value: 'patch', label: 'Patch', color: '#059669' },
//   { value: 'hotfix', label: 'Hotfix', color: '#DC2626' },
//   { value: 'beta', label: 'Beta', color: '#7C3AED' },
//   { value: 'rc', label: 'Release Candidate', color: '#2563EB' }
// ];

// const VersionManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [versions, setVersions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [stats, setStats] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [editingVersion, setEditingVersion] = useState(null);
//   const [viewingVersion, setViewingVersion] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
  
//   // ✅ Search with debounce
//   const [searchTerm, setSearchTerm] = useState('');
//   const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
//   const searchTimeoutRef = useRef(null);
  
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [pageSize] = useState(10);
//   const [totalVersions, setTotalVersions] = useState(0);

//   const [filters, setFilters] = useState({
//     appType: '',
//     platform: '',
//     isActive: '',
//     isLatest: ''
//   });

//   const [formData, setFormData] = useState({
//     appType: 'user',
//     version: '',
//     platform: 'all',
//     description: '',
//     releaseNotes: '',
//     features: [''],
//     bugFixes: [''],
//     improvements: [''],
//     breakingChanges: [''],
//     isMandatory: false,
//     isLatest: false,
//     isActive: true,
//     downloadUrls: {
//       ios: '',
//       android: '',
//       web: ''
//     },
//     appStoreId: '',
//     playStoreId: '',
//     minSupportedVersion: '',
//     maxSupportedVersion: '',
//     size: '',
//     releaseType: 'patch'
//   });

//   // ============================================================
//   // ✅ API FUNCTIONS
//   // ============================================================

//   const fetchVersions = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const params = {
//         page: currentPage,
//         limit: pageSize,
//         ...(filters.appType && { appType: filters.appType }),
//         ...(filters.platform && { platform: filters.platform }),
//         ...(filters.isActive !== '' && { isActive: filters.isActive }),
//         ...(filters.isLatest !== '' && { isLatest: filters.isLatest }),
//         ...(debouncedSearchTerm && { search: debouncedSearchTerm })
//       };

//       const response = await getVersions(token, params);
//       if (response.success) {
//         setVersions(response.data || []);
//         setTotalPages(response.pagination?.totalPages || 1);
//         setTotalVersions(response.pagination?.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch versions');
//       console.error('Error fetching versions:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchStats = async () => {
//     try {
//       const response = await getVersionStats(token);
//       if (response.success) {
//         setStats(response.data);
//       }
//     } catch (err) {
//       console.error('Error fetching stats:', err);
//     }
//   };

//   // ============================================================
//   // ✅ EFFECTS WITH DEBOUNCED SEARCH
//   // ============================================================

//   useEffect(() => {
//     fetchVersions();
//   }, [currentPage, filters, debouncedSearchTerm]);

//   useEffect(() => {
//     fetchStats();
//   }, []);

//   // ✅ Cleanup timeout on unmount
//   useEffect(() => {
//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, []);

//   // ============================================================
//   // ✅ SEARCH HANDLER WITH DEBOUNCE
//   // ============================================================

//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     setCurrentPage(1);
    
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }
    
//     searchTimeoutRef.current = setTimeout(() => {
//       setDebouncedSearchTerm(value);
//     }, 500);
//   };

//   // ============================================================
//   // ✅ FILTER HANDLERS
//   // ============================================================

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({ ...prev, [name]: value }));
//     setCurrentPage(1);
//   };

//   const clearFilters = () => {
//     setFilters({
//       appType: '',
//       platform: '',
//       isActive: '',
//       isLatest: ''
//     });
//     setSearchTerm('');
//     setDebouncedSearchTerm('');
//     setCurrentPage(1);
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }
//   };

//   // ============================================================
//   // ✅ FORM HANDLERS
//   // ============================================================

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     if (name.includes('.')) {
//       const [parent, child] = name.split('.');
//       setFormData(prev => ({
//         ...prev,
//         [parent]: {
//           ...prev[parent],
//           [child]: value
//         }
//       }));
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value
//       }));
//     }
//   };

//   const handleArrayFieldChange = (field, index, value) => {
//     setFormData(prev => {
//       const newArray = [...prev[field]];
//       newArray[index] = value;
//       return { ...prev, [field]: newArray };
//     });
//   };

//   const addArrayItem = (field) => {
//     setFormData(prev => ({
//       ...prev,
//       [field]: [...prev[field], '']
//     }));
//   };

//   // ✅ FIXED: removeArrayItem with functional guard
//   const removeArrayItem = (field, index) => {
//     setFormData(prev => {
//       if (prev[field].length <= 1) return prev;
//       const newArray = prev[field].filter((_, i) => i !== index);
//       return { ...prev, [field]: newArray };
//     });
//   };

//   // ============================================================
//   // ✅ FORM RESET & MODAL HANDLERS
//   // ============================================================

//   const resetForm = () => {
//     setFormData({
//       appType: 'user',
//       version: '',
//       platform: 'all',
//       description: '',
//       releaseNotes: '',
//       features: [''],
//       bugFixes: [''],
//       improvements: [''],
//       breakingChanges: [''],
//       isMandatory: false,
//       isLatest: false,
//       isActive: true,
//       downloadUrls: {
//         ios: '',
//         android: '',
//         web: ''
//       },
//       appStoreId: '',
//       playStoreId: '',
//       minSupportedVersion: '',
//       maxSupportedVersion: '',
//       size: '',
//       releaseType: 'patch'
//     });
//     setEditingVersion(null);
//   };

//   const handleOpenCreate = () => {
//     resetForm();
//     setShowModal(true);
//   };

//   const handleOpenEdit = (version) => {
//     setEditingVersion(version._id);
//     setFormData({
//       appType: version.appType || 'user',
//       version: version.version || '',
//       platform: version.platform || 'all',
//       description: version.description || '',
//       releaseNotes: version.releaseNotes || '',
//       features: version.features?.length ? version.features : [''],
//       bugFixes: version.bugFixes?.length ? version.bugFixes : [''],
//       improvements: version.improvements?.length ? version.improvements : [''],
//       breakingChanges: version.breakingChanges?.length ? version.breakingChanges : [''],
//       isMandatory: version.isMandatory || false,
//       isLatest: version.isLatest || false,
//       isActive: version.isActive !== undefined ? version.isActive : true,
//       downloadUrls: {
//         ios: version.downloadUrls?.ios || '',
//         android: version.downloadUrls?.android || '',
//         web: version.downloadUrls?.web || ''
//       },
//       appStoreId: version.appStoreId || '',
//       playStoreId: version.playStoreId || '',
//       minSupportedVersion: version.minSupportedVersion || '',
//       maxSupportedVersion: version.maxSupportedVersion || '',
//       size: version.size || '',
//       releaseType: version.releaseType || 'patch'
//     });
//     setShowModal(true);
//   };

//   // ============================================================
//   // ✅ SUBMIT HANDLER
//   // ============================================================

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     setError(null);

//     try {
//       if (!/^\d+\.\d+\.\d+$/.test(formData.version)) {
//         toast.error('Version must be in format x.y.z (e.g., 1.0.0)');
//         setIsSubmitting(false);
//         return;
//       }

//       const submitData = {
//         ...formData,
//         features: formData.features.filter(f => f.trim()),
//         bugFixes: formData.bugFixes.filter(f => f.trim()),
//         improvements: formData.improvements.filter(f => f.trim()),
//         breakingChanges: formData.breakingChanges.filter(f => f.trim()),
//         size: formData.size ? parseFloat(formData.size) : undefined
//       };

//       let response;
//       if (editingVersion) {
//         response = await updateVersion(editingVersion, submitData, token);
//       } else {
//         response = await createVersion(submitData, token);
//       }

//       if (response.success) {
//         toast.success(editingVersion ? 'Version updated successfully!' : 'Version created successfully!');
//         setShowModal(false);
//         resetForm();
//         fetchVersions();
//         fetchStats();
//       } else {
//         throw new Error(response.message || 'Failed to save version');
//       }
//     } catch (err) {
//       setError(err.message || 'Failed to save version');
//       toast.error(err.message || 'Failed to save version');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // ============================================================
//   // ✅ DELETE, TOGGLE, VIEW HANDLERS
//   // ============================================================

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this version?')) return;

//     try {
//       const response = await deleteVersion(id, token);
//       if (response.success) {
//         toast.success('Version deleted successfully!');
//         fetchVersions();
//         fetchStats();
//       } else {
//         throw new Error(response.message || 'Failed to delete version');
//       }
//     } catch (err) {
//       toast.error(err.message || 'Failed to delete version');
//     }
//   };

//   const handleToggleStatus = async (id) => {
//     try {
//       const response = await toggleVersionStatus(id, token);
//       if (response.success) {
//         toast.success(response.message || 'Status toggled successfully');
//         fetchVersions();
//         fetchStats();
//       } else {
//         throw new Error(response.message || 'Failed to toggle status');
//       }
//     } catch (err) {
//       toast.error(err.message || 'Failed to toggle status');
//     }
//   };

//   const handleView = (version) => {
//     setViewingVersion(version);
//   };

//   const closeViewModal = () => {
//     setViewingVersion(null);
//   };

//   // ============================================================
//   // ✅ HELPER FUNCTIONS
//   // ============================================================

//   const getAppLabel = (appType) => {
//     const app = appTypes.find(a => a.id === appType);
//     return app ? app.label : appType;
//   };

//   const getAppIcon = (appType) => {
//     const app = appTypes.find(a => a.id === appType);
//     return app ? app.icon : '📱';
//   };

//   const getAppColor = (appType) => {
//     const app = appTypes.find(a => a.id === appType);
//     return app ? app.color : '#6B7280';
//   };

//   const getPlatformLabel = (platform) => {
//     const option = platformOptions.find(p => p.value === platform);
//     return option ? option.label : platform;
//   };

//   const getReleaseTypeLabel = (type) => {
//     const option = releaseTypeOptions.find(r => r.value === type);
//     return option ? option.label : type;
//   };

//   const getReleaseTypeColor = (type) => {
//     const option = releaseTypeOptions.find(r => r.value === type);
//     return option ? option.color : '#6B7280';
//   };

//   // ============================================================
//   // ✅ SKELETON COMPONENTS
//   // ============================================================

//   const SkeletonRow = () => (
//     <tr className="skeleton-row">
//       <td><div className="skeleton-cell"></div></td>
//       <td><div className="skeleton-cell"></div></td>
//       <td><div className="skeleton-cell"></div></td>
//       <td><div className="skeleton-cell"></div></td>
//       <td><div className="skeleton-cell"></div></td>
//       <td><div className="skeleton-cell"></div></td>
//       <td><div className="skeleton-badge"></div></td>
//       <td><div className="skeleton-actions"></div></td>
//     </tr>
//   );

//   // ============================================================
//   // ✅ RENDER
//   // ============================================================

//   return (
//     <div className="management-page">

//       <div className="page-header">
//         <div className="header-left">
//           <h1>Version Management</h1>
//           <div className="header-stats">
//             <span>Total: {totalVersions}</span>
//             {stats?.overall && (
//               <>
//                 <span>Active: {stats.overall.totalActive}</span>
//                 <span>Inactive: {stats.overall.totalInactive}</span>
//               </>
//             )}
//           </div>
//         </div>
//         <div className="header-actions">
//           <button className="create-btn" onClick={handleOpenCreate}>
//             + Create Version
//           </button>
//         </div>
//       </div>

//       {/* ============================================================
//           FILTERS
//           ============================================================ */}

//       <div className="filters-container">
//         <div className="filters-row">
//           <div className="filter-group">
//             <label>App Type</label>
//             <select
//               name="appType"
//               value={filters.appType}
//               onChange={handleFilterChange}
//             >
//               <option value="">All Apps</option>
//               {appTypes.map(app => (
//                 <option key={app.id} value={app.id}>{app.label}</option>
//               ))}
//             </select>
//           </div>

//           <div className="filter-group">
//             <label>Platform</label>
//             <select
//               name="platform"
//               value={filters.platform}
//               onChange={handleFilterChange}
//             >
//               <option value="">All Platforms</option>
//               {platformOptions.map(option => (
//                 <option key={option.value} value={option.value}>{option.label}</option>
//               ))}
//             </select>
//           </div>

//           <div className="filter-group">
//             <label>Status</label>
//             <select
//               name="isActive"
//               value={filters.isActive}
//               onChange={handleFilterChange}
//             >
//               <option value="">All</option>
//               <option value="true">Active</option>
//               <option value="false">Inactive</option>
//             </select>
//           </div>

//           <div className="filter-group">
//             <label>Latest</label>
//             <select
//               name="isLatest"
//               value={filters.isLatest}
//               onChange={handleFilterChange}
//             >
//               <option value="">All</option>
//               <option value="true">Latest</option>
//               <option value="false">Not Latest</option>
//             </select>
//           </div>

//           <div className="filter-group search-group">
//             <input
//               type="text"
//               placeholder="Search versions..."
//               value={searchTerm}
//               onChange={handleSearch}
//               className="search-input"
//             />
//           </div>

//           <button className="clear-filters-btn" onClick={clearFilters}>
//             Clear Filters
//           </button>
//         </div>
//       </div>

//       {/* ============================================================
//           STATS CARDS
//           ============================================================ */}

//       {stats && (
//         <div className="stats-cards">
//           <div className="stat-card">
//             <h3>Total Versions</h3>
//             <p>{stats.overall.totalVersions}</p>
//             <span>Across all apps</span>
//           </div>
//           <div className="stat-card">
//             <h3>Active</h3>
//             <p>{stats.overall.totalActive}</p>
//             <span>Active versions</span>
//           </div>
//           <div className="stat-card">
//             <h3>Inactive</h3>
//             <p>{stats.overall.totalInactive}</p>
//             <span>Inactive versions</span>
//           </div>
//           <div className="stat-card">
//             <h3>Apps</h3>
//             <p>{stats.overall.totalApps}</p>
//             <span>Total apps</span>
//           </div>
//         </div>
//       )}

//       {/* ============================================================
//           ERROR MESSAGE
//           ============================================================ */}

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       {/* ============================================================
//           TABLE
//           ============================================================ */}

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>App</th>
//               <th>Version</th>
//               <th>Platform</th>
//               <th>Release Type</th>
//               <th>Description</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {loading ? (
//               Array.from({ length: 5 }).map((_, i) => <SkeletonRow key={i} />)
//             ) : versions.length > 0 ? (
//               versions.map((version, index) => (
//                 <tr key={version._id} className={version.isLatest ? 'latest-row' : ''}>
//                   <td>{(currentPage - 1) * pageSize + index + 1}</td>
//                   <td>
//                     <div className="app-badge" style={{
//                       backgroundColor: getAppColor(version.appType) + '20',
//                       color: getAppColor(version.appType)
//                     }}>
//                       <span>{getAppIcon(version.appType)}</span>
//                       {getAppLabel(version.appType)}
//                     </div>
//                   </td>
//                   <td>
//                     <strong>{version.version}</strong>
//                     {version.isLatest && (
//                       <span className="latest-badge">Latest</span>
//                     )}
//                   </td>
//                   <td>{getPlatformLabel(version.platform)}</td>
//                   <td>
//                     <span className="release-type-badge" style={{
//                       backgroundColor: getReleaseTypeColor(version.releaseType) + '20',
//                       color: getReleaseTypeColor(version.releaseType)
//                     }}>
//                       {getReleaseTypeLabel(version.releaseType)}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="description-cell" title={version.description}>
//                       {version.description?.length > 30 
//                         ? version.description.substring(0, 30) + '...' 
//                         : version.description}
//                     </div>
//                   </td>
//                   <td>
//                     <span className={`status-badge ${version.isActive ? 'active' : 'inactive'}`}>
//                       {version.isActive ? 'Active' : 'Inactive'}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleView(version)}
//                         title="View Details"
//                       >
//                         👁
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleOpenEdit(version)}
//                         title="Edit"
//                       >
//                         ✏️
//                       </button>
//                       <button
//                         className={`action-btn ${version.isActive ? 'deactivate' : 'activate'}`}
//                         onClick={() => handleToggleStatus(version._id)}
//                         title={version.isActive ? 'Deactivate' : 'Activate'}
//                       >
//                         {version.isActive ? '🔴' : '🟢'}
//                       </button>
//                       <button
//                         className="action-btn delete"
//                         onClick={() => handleDelete(version._id)}
//                         title="Delete"
//                       >
//                         🗑️
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="no-data">
//                   <p>No versions found</p>
//                   <button className="create-btn" onClick={handleOpenCreate}>
//                     Create your first version
//                   </button>
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ============================================================
//           PAGINATION
//           ============================================================ */}

//       {totalPages > 1 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {versions.length} of {totalVersions} versions
//             (Page {currentPage} of {totalPages})
//           </div>
//           <div className="pagination-controls">
//             <button
//               className="pagination-btn"
//               onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>
//             <div className="page-numbers">
//               {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                 let pageNumber;
//                 if (totalPages <= 5) {
//                   pageNumber = i + 1;
//                 } else if (currentPage <= 3) {
//                   pageNumber = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   pageNumber = totalPages - 4 + i;
//                 } else {
//                   pageNumber = currentPage - 2 + i;
//                 }
//                 return (
//                   <button
//                     key={pageNumber}
//                     className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                     onClick={() => setCurrentPage(pageNumber)}
//                   >
//                     {pageNumber}
//                   </button>
//                 );
//               })}
//             </div>
//             <button
//               className="pagination-btn"
//               onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ============================================================
//           CREATE/EDIT MODAL
//           ============================================================ */}

//       {showModal && (
//         <div className="modal-overlay" onClick={() => setShowModal(false)}>
//           <div className="modal-content1 version-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>{editingVersion ? 'Edit Version' : 'Create New Version'}</h3>
//               <button className="modal-close-btn" onClick={() => setShowModal(false)}>
//                 ×
//               </button>
//             </div>
//             <form onSubmit={handleSubmit} className="version-form">
//               <div className="modal-body">
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>App Type *</label>
//                     <select
//                       name="appType"
//                       value={formData.appType}
//                       onChange={handleInputChange}
//                       required
//                     >
//                       {appTypes.map(app => (
//                         <option key={app.id} value={app.id}>{app.label}</option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className="form-group">
//                     <label>Version *</label>
//                     <input
//                       type="text"
//                       name="version"
//                       value={formData.version}
//                       onChange={handleInputChange}
//                       placeholder="e.g., 1.0.0"
//                       required
//                     />
//                     <small>Format: major.minor.patch</small>
//                   </div>
//                 </div>

//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Platform</label>
//                     <select
//                       name="platform"
//                       value={formData.platform}
//                       onChange={handleInputChange}
//                     >
//                       {platformOptions.map(option => (
//                         <option key={option.value} value={option.value}>
//                           {option.label}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className="form-group">
//                     <label>Release Type</label>
//                     <select
//                       name="releaseType"
//                       value={formData.releaseType}
//                       onChange={handleInputChange}
//                     >
//                       {releaseTypeOptions.map(option => (
//                         <option key={option.value} value={option.value}>
//                           {option.label}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>

//                 <div className="form-group">
//                   <label>Description *</label>
//                   <input
//                     type="text"
//                     name="description"
//                     value={formData.description}
//                     onChange={handleInputChange}
//                     placeholder="Brief description of this version"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Release Notes</label>
//                   <textarea
//                     name="releaseNotes"
//                     value={formData.releaseNotes}
//                     onChange={handleInputChange}
//                     placeholder="Detailed release notes..."
//                     rows="2"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Features</label>
//                   {formData.features.map((feature, index) => (
//                     <div key={index} className="array-input-group">
//                       <input
//                         type="text"
//                         value={feature}
//                         onChange={(e) => handleArrayFieldChange('features', index, e.target.value)}
//                         placeholder={`Feature ${index + 1}`}
//                       />
//                       <button
//                         type="button"
//                         className="remove-btn"
//                         onClick={() => removeArrayItem('features', index)}
//                         disabled={formData.features.length <= 1}
//                       >
//                         ×
//                       </button>
//                       {index === formData.features.length - 1 && (
//                         <button
//                           type="button"
//                           className="add-btn"
//                           onClick={() => addArrayItem('features')}
//                         >
//                           +
//                         </button>
//                       )}
//                     </div>
//                   ))}
//                 </div>

//                 <div className="form-group">
//                   <label>Bug Fixes</label>
//                   {formData.bugFixes.map((bug, index) => (
//                     <div key={index} className="array-input-group">
//                       <input
//                         type="text"
//                         value={bug}
//                         onChange={(e) => handleArrayFieldChange('bugFixes', index, e.target.value)}
//                         placeholder={`Bug Fix ${index + 1}`}
//                       />
//                       <button
//                         type="button"
//                         className="remove-btn"
//                         onClick={() => removeArrayItem('bugFixes', index)}
//                         disabled={formData.bugFixes.length <= 1}
//                       >
//                         ×
//                       </button>
//                       {index === formData.bugFixes.length - 1 && (
//                         <button
//                           type="button"
//                           className="add-btn"
//                           onClick={() => addArrayItem('bugFixes')}
//                         >
//                           +
//                         </button>
//                       )}
//                     </div>
//                   ))}
//                 </div>

//                 <div className="form-group">
//                   <label>Improvements</label>
//                   {formData.improvements.map((improvement, index) => (
//                     <div key={index} className="array-input-group">
//                       <input
//                         type="text"
//                         value={improvement}
//                         onChange={(e) => handleArrayFieldChange('improvements', index, e.target.value)}
//                         placeholder={`Improvement ${index + 1}`}
//                       />
//                       <button
//                         type="button"
//                         className="remove-btn"
//                         onClick={() => removeArrayItem('improvements', index)}
//                         disabled={formData.improvements.length <= 1}
//                       >
//                         ×
//                       </button>
//                       {index === formData.improvements.length - 1 && (
//                         <button
//                           type="button"
//                           className="add-btn"
//                           onClick={() => addArrayItem('improvements')}
//                         >
//                           +
//                         </button>
//                       )}
//                     </div>
//                   ))}
//                 </div>

//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>App Store ID</label>
//                     <input
//                       type="text"
//                       name="appStoreId"
//                       value={formData.appStoreId}
//                       onChange={handleInputChange}
//                       placeholder="iOS App Store ID"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Play Store ID</label>
//                     <input
//                       type="text"
//                       name="playStoreId"
//                       value={formData.playStoreId}
//                       onChange={handleInputChange}
//                       placeholder="Android Play Store ID"
//                     />
//                   </div>
//                 </div>

//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Size (MB)</label>
//                     <input
//                       type="number"
//                       name="size"
//                       value={formData.size}
//                       onChange={handleInputChange}
//                       placeholder="e.g., 45.2"
//                       step="0.1"
//                       min="0"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Min Supported Version</label>
//                     <input
//                       type="text"
//                       name="minSupportedVersion"
//                       value={formData.minSupportedVersion}
//                       onChange={handleInputChange}
//                       placeholder="e.g., 1.0.0"
//                     />
//                   </div>
//                 </div>

//                 <div className="form-row checkbox-row">
//                   <div className="form-group checkbox-group">
//                     <label className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         name="isMandatory"
//                         checked={formData.isMandatory}
//                         onChange={handleInputChange}
//                       />
//                       <span>Mandatory Update</span>
//                     </label>
//                   </div>
//                   <div className="form-group checkbox-group">
//                     <label className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         name="isLatest"
//                         checked={formData.isLatest}
//                         onChange={handleInputChange}
//                       />
//                       <span>Mark as Latest</span>
//                     </label>
//                   </div>
//                   <div className="form-group checkbox-group">
//                     <label className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         name="isActive"
//                         checked={formData.isActive}
//                         onChange={handleInputChange}
//                       />
//                       <span>Active</span>
//                     </label>
//                   </div>
//                 </div>
//               </div>

//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="action-btn cancel"
//                   onClick={() => setShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="action-btn save"
//                   disabled={isSubmitting}
//                 >
//                   {isSubmitting ? 'Saving...' : (editingVersion ? 'Update' : 'Create')}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* ============================================================
//           VIEW MODAL
//           ============================================================ */}

//       {viewingVersion && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1 view-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Version Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="version-details">
//                 <div className="detail-row">
//                   <label>App:</label>
//                   <span className="app-badge" style={{
//                     backgroundColor: getAppColor(viewingVersion.appType) + '20',
//                     color: getAppColor(viewingVersion.appType)
//                   }}>
//                     {getAppIcon(viewingVersion.appType)} {getAppLabel(viewingVersion.appType)}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Version:</label>
//                   <span>
//                     <strong>{viewingVersion.version}</strong>
//                     {viewingVersion.isLatest && (
//                       <span className="latest-badge" style={{ marginLeft: '10px' }}>Latest</span>
//                     )}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Platform:</label>
//                   <span>{getPlatformLabel(viewingVersion.platform)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Release Type:</label>
//                   <span className="release-type-badge" style={{
//                     backgroundColor: getReleaseTypeColor(viewingVersion.releaseType) + '20',
//                     color: getReleaseTypeColor(viewingVersion.releaseType)
//                   }}>
//                     {getReleaseTypeLabel(viewingVersion.releaseType)}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Release Date:</label>
//                   <span>{new Date(viewingVersion.releaseDate).toLocaleDateString()}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Description:</label>
//                   <span>{viewingVersion.description}</span>
//                 </div>
//                 {viewingVersion.releaseNotes && (
//                   <div className="detail-row">
//                     <label>Release Notes:</label>
//                     <span>{viewingVersion.releaseNotes}</span>
//                   </div>
//                 )}
//                 {viewingVersion.features?.length > 0 && (
//                   <div className="detail-row">
//                     <label>Features:</label>
//                     <ul className="feature-list">
//                       {viewingVersion.features.map((feature, i) => (
//                         <li key={i}>✅ {feature}</li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//                 {viewingVersion.bugFixes?.length > 0 && (
//                   <div className="detail-row">
//                     <label>Bug Fixes:</label>
//                     <ul className="feature-list">
//                       {viewingVersion.bugFixes.map((bug, i) => (
//                         <li key={i}>🐛 {bug}</li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//                 {viewingVersion.improvements?.length > 0 && (
//                   <div className="detail-row">
//                     <label>Improvements:</label>
//                     <ul className="feature-list">
//                       {viewingVersion.improvements.map((improvement, i) => (
//                         <li key={i}>⚡ {improvement}</li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingVersion.isActive ? 'active' : 'inactive'}`}>
//                     {viewingVersion.isActive ? 'Active' : 'Inactive'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Mandatory:</label>
//                   <span>{viewingVersion.isMandatory ? 'Yes' : 'No'}</span>
//                 </div>
//                 {viewingVersion.size && (
//                   <div className="detail-row">
//                     <label>Size:</label>
//                     <span>{viewingVersion.size} MB</span>
//                   </div>
//                 )}
//                 {viewingVersion.downloadUrls && (
//                   <div className="detail-row">
//                     <label>Download URLs:</label>
//                     <div className="download-urls">
//                       {viewingVersion.downloadUrls.ios && (
//                         <a href={viewingVersion.downloadUrls.ios} target="_blank" rel="noopener noreferrer">
//                           iOS
//                         </a>
//                       )}
//                       {viewingVersion.downloadUrls.android && (
//                         <a href={viewingVersion.downloadUrls.android} target="_blank" rel="noopener noreferrer">
//                           Android
//                         </a>
//                       )}
//                       {viewingVersion.downloadUrls.web && (
//                         <a href={viewingVersion.downloadUrls.web} target="_blank" rel="noopener noreferrer">
//                           Web
//                         </a>
//                       )}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default VersionManagement;

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/CustomerReport.css';       // customer-only additions (load LAST)
import '../../Styles/VersionManagement.css';
import {
  getVersions,
  createVersion,
  updateVersion,
  deleteVersion,
  toggleVersionStatus,
  getVersionStats
} from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';

// ---------- constants ----------
const appTypes = [
  { id: 'user',      label: 'User App',       icon: 'user',   tone: 'indigo' },
  { id: 'partner',   label: 'Partner App',    icon: 'users',  tone: 'green'  },
  { id: 'executive', label: 'Executive App',  icon: 'briefcase', tone: 'amber' },
  { id: 'crm',       label: 'CRM App',        icon: 'grid',   tone: 'inactive' }
];

const platformOptions = [
  { value: 'all',     label: 'All Platforms' },
  { value: 'ios',     label: 'iOS' },
  { value: 'android', label: 'Android' },
  { value: 'web',     label: 'Web' }
];

const releaseTypeOptions = [
  { value: 'major',  label: 'Major',             tone: 'inactive' },
  { value: 'minor',  label: 'Minor',             tone: 'pending'  },
  { value: 'patch',  label: 'Patch',             tone: 'active'   },
  { value: 'hotfix', label: 'Hotfix',            tone: 'inactive' },
  { value: 'beta',   label: 'Beta',              tone: 'info'     },
  { value: 'rc',     label: 'Release Candidate', tone: 'pending'  }
];

// ---------- helpers ----------
const getApp = (id) => appTypes.find(a => a.id === id) || { label: id || 'N/A', icon: 'bus', tone: 'inactive' };
const getPlatformLabel = (p) => platformOptions.find(o => o.value === p)?.label || p || 'N/A';
const getReleaseType = (t) => releaseTypeOptions.find(r => r.value === t) || { label: t || 'N/A', tone: 'inactive' };
const safeStr = (v) => (v === null || v === undefined ? '' : String(v));
const safeArr = (v) => (Array.isArray(v) ? v : []);

const AppPill = ({ value }) => {
  const app = getApp(value);
  return <span className={`prm-status tone-${app.tone}`}><Icon name={app.icon} size={12} /> {app.label}</span>;
};
const ReleasePill = ({ value }) => {
  const r = getReleaseType(value);
  return <span className={`prm-status tone-${r.tone}`}>{r.label}</span>;
};
const StatusPill = ({ value }) => (
  <span className={`prm-status ${value ? 'active' : 'inactive'}`}>{value ? 'Active' : 'Inactive'}</span>
);

// ============================================================
// Version card
// ============================================================
const VersionCard = ({ version, index, onView, onEdit, onToggle, onDelete }) => (
  <div className="prm-card cr-card" style={{ animationDelay: `${index * 60}ms` }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <span className="prm-form-badge" style={{ width: 44, height: 44 }}>
          <Icon name="tag" size={20} />
        </span>
        <div>
          <div className="prm-card-no">v{safeStr(version.version)} · {getPlatformLabel(version.platform)}</div>
          <h3 className="prm-card-title">{safeStr(version.description) || 'Untitled version'}</h3>
          <div className="prm-card-sub">
            <Icon name="calendar" size={14} /> {version.releaseDate ? new Date(version.releaseDate).toLocaleDateString() : 'N/A'}
          </div>
        </div>
      </div>
      <StatusPill value={version.isActive} />
    </div>

    <div className="pbo-contact">
      <div><AppPill value={version.appType} /></div>
      <div style={{ marginTop: 4 }}><ReleasePill value={version.releaseType} /></div>
      {version.isLatest && <div style={{ marginTop: 6 }}><span className="prm-tag amber">Latest</span></div>}
      {version.isMandatory && <div style={{ marginTop: 6 }}><span className="prm-tag amber">Mandatory</span></div>}
    </div>

    {(safeArr(version.features).length > 0 || safeArr(version.bugFixes).length > 0) && (
      <div className="prm-metrics">
        <div className="prm-metric">
          <div className="v"><Icon name="check" size={15} /> {safeArr(version.features).length}</div>
          <div className="l">Features</div>
        </div>
        <div className="prm-metric">
          <div className="v"><Icon name="info" size={15} /> {safeArr(version.bugFixes).length}</div>
          <div className="l">Bug fixes</div>
        </div>
        <div className="prm-metric">
          <div className="v"><Icon name="refresh" size={15} /> {safeArr(version.improvements).length}</div>
          <div className="l">Improvements</div>
        </div>
      </div>
    )}

    <div className="pbo-card-actions">
      <button className="prm-btn view sm" onClick={() => onView(version)}>
        <Icon name="eye" size={14} /> View
      </button>
      <button className="prm-btn ghost sm" onClick={() => onEdit(version)}>
        <Icon name="edit" size={14} /> Edit
      </button>
      <button className="prm-btn ghost sm" onClick={() => onToggle(version._id)} title={version.isActive ? 'Deactivate' : 'Activate'}>
        <Icon name={version.isActive ? 'x' : 'check'} size={14} />
      </button>
      <button className="prm-btn ghost sm" onClick={() => onDelete(version._id)} title="Delete">
        <Icon name="trash" size={14} />
      </button>
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const VersionManagement = () => {
  const { token } = useSelector(state => state.user);

  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingVersion, setEditingVersion] = useState(null);
  const [viewingVersion, setViewingVersion] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [layout, setLayout] = useState('table');
  const [showFilters, setShowFilters] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const searchTimeoutRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalVersions, setTotalVersions] = useState(0);
  const totalPages = Math.max(1, Math.ceil(totalVersions / pageSize));

  const [filters, setFilters] = useState({
    appType: '', platform: '', isActive: '', isLatest: ''
  });

  const [formData, setFormData] = useState({
    appType: 'user',
    version: '',
    platform: 'all',
    description: '',
    releaseNotes: '',
    features: [''],
    bugFixes: [''],
    improvements: [''],
    breakingChanges: [''],
    isMandatory: false,
    isLatest: false,
    isActive: true,
    downloadUrls: { ios: '', android: '', web: '' },
    appStoreId: '',
    playStoreId: '',
    minSupportedVersion: '',
    maxSupportedVersion: '',
    size: '',
    releaseType: 'patch'
  });

  // ============================================================
  // FETCH
  // ============================================================
  const fetchVersions = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {
        page: currentPage,
        limit: pageSize,
        ...(filters.appType && { appType: filters.appType }),
        ...(filters.platform && { platform: filters.platform }),
        ...(filters.isActive !== '' && { isActive: filters.isActive }),
        ...(filters.isLatest !== '' && { isLatest: filters.isLatest }),
        ...(debouncedSearchTerm && { search: debouncedSearchTerm })
      };

      const response = await getVersions(token, params);
      if (response.success) {
        setVersions(response.data || []);
        setTotalVersions(response.pagination?.total || 0);
      }
    } catch (err) {
      setError('Failed to fetch versions');
      console.error('Error fetching versions:', err);
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await getVersionStats(token);
      if (response.success) setStats(response.data);
    } catch (err) {
      console.error('Error fetching stats:', err);
    }
  };

  useEffect(() => { fetchVersions(); }, [currentPage, pageSize, filters, debouncedSearchTerm]); // eslint-disable-line
  useEffect(() => { fetchStats(); }, []); // eslint-disable-line
  useEffect(() => { if (currentPage > totalPages) setCurrentPage(totalPages); }, [currentPage, totalPages]);

  useEffect(() => {
    return () => { if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current); };
  }, []);

  // ============================================================
  // SEARCH (debounced)
  // ============================================================
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setCurrentPage(1);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(() => setDebouncedSearchTerm(value), 500);
  };

  // ============================================================
  // FILTERS
  // ============================================================
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setFilters({ appType: '', platform: '', isActive: '', isLatest: '' });
    setSearchTerm('');
    setDebouncedSearchTerm('');
    setCurrentPage(1);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
  };

  const isFiltered = useMemo(() =>
    !!searchTerm || Object.values(filters).some(v => v !== ''), [searchTerm, filters]);

  // ============================================================
  // FORM HANDLERS
  // ============================================================
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData(prev => ({ ...prev, [parent]: { ...prev[parent], [child]: value } }));
    } else {
      setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    }
  };

  const handleArrayFieldChange = (field, index, value) => {
    setFormData(prev => {
      const arr = [...prev[field]];
      arr[index] = value;
      return { ...prev, [field]: arr };
    });
  };

  const addArrayItem = (field) => {
    setFormData(prev => ({ ...prev, [field]: [...prev[field], ''] }));
  };

  const removeArrayItem = (field, index) => {
    setFormData(prev => {
      if (prev[field].length <= 1) return prev;
      return { ...prev, [field]: prev[field].filter((_, i) => i !== index) };
    });
  };

  const resetForm = () => {
    setFormData({
      appType: 'user', version: '', platform: 'all',
      description: '', releaseNotes: '',
      features: [''], bugFixes: [''], improvements: [''], breakingChanges: [''],
      isMandatory: false, isLatest: false, isActive: true,
      downloadUrls: { ios: '', android: '', web: '' },
      appStoreId: '', playStoreId: '',
      minSupportedVersion: '', maxSupportedVersion: '',
      size: '', releaseType: 'patch'
    });
    setEditingVersion(null);
  };

  const handleOpenCreate = () => { resetForm(); setShowModal(true); };

  const handleOpenEdit = (version) => {
    setEditingVersion(version._id);
    setFormData({
      appType: version.appType || 'user',
      version: version.version || '',
      platform: version.platform || 'all',
      description: version.description || '',
      releaseNotes: version.releaseNotes || '',
      features: version.features?.length ? version.features : [''],
      bugFixes: version.bugFixes?.length ? version.bugFixes : [''],
      improvements: version.improvements?.length ? version.improvements : [''],
      breakingChanges: version.breakingChanges?.length ? version.breakingChanges : [''],
      isMandatory: version.isMandatory || false,
      isLatest: version.isLatest || false,
      isActive: version.isActive !== undefined ? version.isActive : true,
      downloadUrls: {
        ios: version.downloadUrls?.ios || '',
        android: version.downloadUrls?.android || '',
        web: version.downloadUrls?.web || ''
      },
      appStoreId: version.appStoreId || '',
      playStoreId: version.playStoreId || '',
      minSupportedVersion: version.minSupportedVersion || '',
      maxSupportedVersion: version.maxSupportedVersion || '',
      size: version.size || '',
      releaseType: version.releaseType || 'patch'
    });
    setShowModal(true);
  };

  // ============================================================
  // SUBMIT / DELETE / TOGGLE / VIEW
  // ============================================================
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      if (!/^\d+\.\d+\.\d+$/.test(formData.version)) {
        toast.error('Version must be in format x.y.z (e.g., 1.0.0)');
        setIsSubmitting(false);
        return;
      }

      const submitData = {
        ...formData,
        features: formData.features.filter(f => f.trim()),
        bugFixes: formData.bugFixes.filter(f => f.trim()),
        improvements: formData.improvements.filter(f => f.trim()),
        breakingChanges: formData.breakingChanges.filter(f => f.trim()),
        size: formData.size ? parseFloat(formData.size) : undefined
      };

      const response = editingVersion
        ? await updateVersion(editingVersion, submitData, token)
        : await createVersion(submitData, token);

      if (response.success) {
        toast.success(editingVersion ? 'Version updated successfully' : 'Version created successfully');
        setShowModal(false);
        resetForm();
        fetchVersions();
        fetchStats();
      } else {
        throw new Error(response.message || 'Failed to save version');
      }
    } catch (err) {
      setError(err.message || 'Failed to save version');
      toast.error(err.message || 'Failed to save version');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this version?')) return;
    try {
      const response = await deleteVersion(id, token);
      if (response.success) {
        toast.success('Version deleted successfully');
        fetchVersions();
        fetchStats();
      } else {
        throw new Error(response.message || 'Failed to delete version');
      }
    } catch (err) {
      toast.error(err.message || 'Failed to delete version');
    }
  };

  const handleToggleStatus = async (id) => {
    try {
      const response = await toggleVersionStatus(id, token);
      if (response.success) {
        toast.success(response.message || 'Status toggled successfully');
        fetchVersions();
        fetchStats();
      } else {
        throw new Error(response.message || 'Failed to toggle status');
      }
    } catch (err) {
      toast.error(err.message || 'Failed to toggle status');
    }
  };

  const handleView = (version) => setViewingVersion(version);
  const closeViewModal = () => setViewingVersion(null);

  // ============================================================
  // LOADING
  // ============================================================
  if (firstLoad && loading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="tag" size={13} /> Releases</span>
          <h1>Version Management</h1><p>Loading versions…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">
          {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  // ============================================================
  // RENDER
  // ============================================================
  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="tag" size={13} /> App Releases</span>
          <h1>Version Management</h1>
          <p>Publish, track, and manage releases across all your apps and platforms.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input
              type="text"
              placeholder="Search versions…"
              value={searchTerm}
              onChange={handleSearch}
            />
            {searchTerm && (
              <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setDebouncedSearchTerm(''); setCurrentPage(1); }}>×</button>
            )}
          </div>
          <button className="pbo-icon-btn" onClick={() => setShowFilters(!showFilters)} title="Filters">
            <Icon name="list" size={17} />
          </button>
          <button className="pbo-icon-btn" onClick={() => { fetchVersions(); fetchStats(); }} title="Refresh">
            <Icon name="refresh" size={17} />
          </button>
          <button className="prm-add-btn" onClick={handleOpenCreate}>
            <span className="plus"><Icon name="plus" size={14} /></span> Create Version
          </button>
        </div>
      </div>

      {error && (
        <div className="cr-error">
          <Icon name="info" size={16} /> {error}
          <button className="prm-btn ghost sm" onClick={fetchVersions}>Retry</button>
        </div>
      )}

      {/* STATS */}
      {stats?.overall && (
        <div className="prm-stats">
          <StatCard icon="tag" tone="indigo" label="Total Versions" value={stats.overall.totalVersions} hint="Across all apps" delay={80} />
          <StatCard icon="check" tone="green" label="Active" value={stats.overall.totalActive} hint="Active versions" delay={160} />
          <StatCard icon="x" tone="inactive" label="Inactive" value={stats.overall.totalInactive} hint="Inactive versions" delay={240} />
          <StatCard icon="grid" tone="cyan" label="Apps" value={stats.overall.totalApps} hint="Total apps" delay={320} />
        </div>
      )}

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            <button
              className={`prm-chip ${filters.isActive === '' ? 'active' : ''}`}
              onClick={() => { setFilters(f => ({ ...f, isActive: '' })); setCurrentPage(1); }}
            >
              All <span className="count">{versions.length}</span>
            </button>
            <button
              className={`prm-chip ${filters.isActive === 'true' ? 'active' : ''}`}
              onClick={() => { setFilters(f => ({ ...f, isActive: 'true' })); setCurrentPage(1); }}
            >
              Active
            </button>
            <button
              className={`prm-chip ${filters.isActive === 'false' ? 'active' : ''}`}
              onClick={() => { setFilters(f => ({ ...f, isActive: 'false' })); setCurrentPage(1); }}
            >
              Inactive
            </button>
            <button
              className={`prm-chip ${filters.isLatest === 'true' ? 'active' : ''}`}
              onClick={() => { setFilters(f => ({ ...f, isLatest: f.isLatest === 'true' ? '' : 'true' })); setCurrentPage(1); }}
            >
              <Icon name="check" size={12} /> Latest only
            </button>
          </div>
          {searchTerm && <span className="prm-tag amber">Search: “{searchTerm}”</span>}
          {loading && versions.length > 0 && <span className="prm-tag gray">loading…</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{versions.length}</b> of {totalVersions}</span>
          <div className="prm-layout-toggle">
            <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view">
              <Icon name="grid" size={17} />
            </button>
            <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view">
              <Icon name="list" size={17} />
            </button>
          </div>
        </div>
      </div>

      {/* FILTER PANEL */}
      {showFilters && (
        <div className="prm-form-modal prm-form-modal-sm" style={{ marginBottom: 16 }}>
          <div className="prm-form-head">
            <div className="prm-form-head-row">
              <span className="prm-form-badge"><Icon name="search" size={22} /></span>
              <div><h3>Filter versions</h3><p>Refine the current result set</p></div>
            </div>
            <button className="prm-modal-close" onClick={() => setShowFilters(false)}>×</button>
          </div>
          <div className="prm-form-body">
            <div className="prm-fgrid">
              <Field label="App Type">
                <select className="prm-input prm-select" name="appType" value={filters.appType} onChange={handleFilterChange}>
                  <option value="">All Apps</option>
                  {appTypes.map(app => <option key={app.id} value={app.id}>{app.label}</option>)}
                </select>
              </Field>
              <Field label="Platform">
                <select className="prm-input prm-select" name="platform" value={filters.platform} onChange={handleFilterChange}>
                  <option value="">All Platforms</option>
                  {platformOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </Field>
              <Field label="Status">
                <select className="prm-input prm-select" name="isActive" value={filters.isActive} onChange={handleFilterChange}>
                  <option value="">All</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </Field>
              <Field label="Latest">
                <select className="prm-input prm-select" name="isLatest" value={filters.isLatest} onChange={handleFilterChange}>
                  <option value="">All</option>
                  <option value="true">Latest</option>
                  <option value="false">Not Latest</option>
                </select>
              </Field>
            </div>
          </div>
          <div className="prm-form-foot">
            <span className="prm-foot-hint">{isFiltered ? 'Filters active' : 'No active filters'}</span>
            <div className="prm-form-foot-actions">
              <button className="prm-btn ghost" onClick={clearFilters}>Clear all</button>
              <button className="prm-btn primary" onClick={() => setShowFilters(false)}>Apply</button>
            </div>
          </div>
        </div>
      )}

      {/* LIST */}
      <div className={loading && versions.length > 0 ? 'cr-loading' : ''}>
        {versions.length === 0 && !loading ? (
          <div className="prm-empty">
            <div className="icon"><Icon name={searchTerm || isFiltered ? 'search' : 'tag'} size={44} /></div>
            <h3>{searchTerm || isFiltered ? 'No versions match your filters' : 'No versions yet'}</h3>
            <p>{searchTerm || isFiltered ? 'Try a different search or clear the filters.' : 'Click “Create Version” to publish your first release.'}</p>
            {(searchTerm || isFiltered)
              ? <button className="prm-btn ghost" onClick={clearFilters}>Clear filters</button>
              : <button className="prm-btn primary" onClick={handleOpenCreate}><Icon name="plus" size={15} /> Create Version</button>}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {versions.map((version, i) => (
              <VersionCard
                key={version._id}
                version={version}
                index={i}
                onView={handleView}
                onEdit={handleOpenEdit}
                onToggle={handleToggleStatus}
                onDelete={handleDelete}
              />
            ))}
          </div>
        ) : (
          <div className="prm-table-wrap">
            <table className="prm-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>App</th>
                  <th>Version</th>
                  <th>Platform</th>
                  <th>Release Type</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {versions.map((version, index) => (
                  <tr key={version._id} style={{ animationDelay: `${index * 50}ms` }}>
                    <td>{(currentPage - 1) * pageSize + index + 1}</td>
                    <td><AppPill value={version.appType} /></td>
                    <td>
                      <b>{version.version}</b>
                      {version.isLatest && <span className="prm-tag amber" style={{ marginLeft: 8 }}>Latest</span>}
                      {version.isMandatory && <span className="prm-tag amber" style={{ marginLeft: 6 }}>Mandatory</span>}
                    </td>
                    <td>{getPlatformLabel(version.platform)}</td>
                    <td><ReleasePill value={version.releaseType} /></td>
                    <td>
                      <div title={version.description}>
                        {safeStr(version.description).length > 30
                          ? safeStr(version.description).substring(0, 30) + '…'
                          : safeStr(version.description)}
                      </div>
                    </td>
                    <td><StatusPill value={version.isActive} /></td>
                    <td>
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleView(version)} title="View"><Icon name="eye" size={13} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleOpenEdit(version)} title="Edit"><Icon name="edit" size={13} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleToggleStatus(version._id)} title={version.isActive ? 'Deactivate' : 'Activate'}><Icon name={version.isActive ? 'x' : 'check'} size={13} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleDelete(version._id)} title="Delete"><Icon name="trash" size={13} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION */}
      <Pagination
        page={currentPage} pageSize={pageSize} total={totalVersions}
        onPage={(p) => setCurrentPage(Math.min(Math.max(1, p), totalPages))}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); }}
        sizes={[10, 25, 50, 100]} label="versions"
      />

      {/* CREATE / EDIT MODAL */}
      {showModal && (
        <div className="prm-overlay" onClick={() => setShowModal(false)}>
          <div className="prm-form-modal" style={{ maxWidth: 780 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name={editingVersion ? 'edit' : 'plus'} size={22} /></span>
                <div>
                  <h3>{editingVersion ? 'Edit version' : 'Create new version'}</h3>
                  <p>Publish a new release for an app</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>

            <div className="prm-form-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {error && <div className="cr-error" style={{ marginBottom: 12 }}><Icon name="info" size={16} /> {error}</div>}

              <div className="prm-fgrid">
                <Field label="App Type" required>
                  <select className="prm-input prm-select" name="appType" value={formData.appType} onChange={handleInputChange}>
                    {appTypes.map(app => <option key={app.id} value={app.id}>{app.label}</option>)}
                  </select>
                </Field>
                <Field label="Version" required note="Format: major.minor.patch">
                  <input className="prm-input" name="version" value={formData.version} onChange={handleInputChange} placeholder="e.g., 1.0.0" />
                </Field>
                <Field label="Platform">
                  <select className="prm-input prm-select" name="platform" value={formData.platform} onChange={handleInputChange}>
                    {platformOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                  </select>
                </Field>
                <Field label="Release Type">
                  <select className="prm-input prm-select" name="releaseType" value={formData.releaseType} onChange={handleInputChange}>
                    {releaseTypeOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                  </select>
                </Field>
                <Field label="Description" required full>
                  <input className="prm-input" name="description" value={formData.description} onChange={handleInputChange} placeholder="Brief description of this version" />
                </Field>
                <Field label="Release Notes" full>
                  <textarea className="prm-input" name="releaseNotes" value={formData.releaseNotes} onChange={handleInputChange} rows="2" placeholder="Detailed release notes…" />
                </Field>
              </div>

              {/* Dynamic arrays */}
              {[
                ['features', 'Features'],
                ['bugFixes', 'Bug Fixes'],
                ['improvements', 'Improvements'],
                ['breakingChanges', 'Breaking Changes']
              ].map(([field, label]) => (
                <div key={field} style={{ marginTop: 12 }}>
                  <div className="prm-section-title">{label}</div>
                  {formData[field].map((val, index) => (
                    <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                      <input
                        className="prm-input"
                        value={val}
                        onChange={(e) => handleArrayFieldChange(field, index, e.target.value)}
                        placeholder={`${label.slice(0, -1)} ${index + 1}`}
                      />
                      <button
                        type="button"
                        className="prm-btn ghost sm"
                        onClick={() => removeArrayItem(field, index)}
                        disabled={formData[field].length <= 1}
                        title="Remove"
                      >
                        <Icon name="trash" size={14} />
                      </button>
                      {index === formData[field].length - 1 && (
                        <button type="button" className="prm-btn ghost sm" onClick={() => addArrayItem(field)} title="Add">
                          <Icon name="plus" size={14} />
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              ))}

              <div className="prm-fgrid" style={{ marginTop: 12 }}>
                <Field label="App Store ID">
                  <input className="prm-input" name="appStoreId" value={formData.appStoreId} onChange={handleInputChange} placeholder="iOS App Store ID" />
                </Field>
                <Field label="Play Store ID">
                  <input className="prm-input" name="playStoreId" value={formData.playStoreId} onChange={handleInputChange} placeholder="Android Play Store ID" />
                </Field>
                <Field label="Size (MB)">
                  <input type="number" step="0.1" min="0" className="prm-input" name="size" value={formData.size} onChange={handleInputChange} placeholder="e.g., 45.2" />
                </Field>
                <Field label="Min Supported Version">
                  <input className="prm-input" name="minSupportedVersion" value={formData.minSupportedVersion} onChange={handleInputChange} placeholder="e.g., 1.0.0" />
                </Field>
              </div>

              <div className="prm-section-title">Flags</div>
              <div className="prm-chips" style={{ flexWrap: 'wrap' }}>
                <button
                  type="button"
                  className={`prm-chip ${formData.isMandatory ? 'active' : ''}`}
                  onClick={() => setFormData(p => ({ ...p, isMandatory: !p.isMandatory }))}
                >
                  {formData.isMandatory && <Icon name="check" size={12} />} Mandatory Update
                </button>
                <button
                  type="button"
                  className={`prm-chip ${formData.isLatest ? 'active' : ''}`}
                  onClick={() => setFormData(p => ({ ...p, isLatest: !p.isLatest }))}
                >
                  {formData.isLatest && <Icon name="check" size={12} />} Mark as Latest
                </button>
                <button
                  type="button"
                  className={`prm-chip ${formData.isActive ? 'active' : ''}`}
                  onClick={() => setFormData(p => ({ ...p, isActive: !p.isActive }))}
                >
                  {formData.isActive && <Icon name="check" size={12} />} Active
                </button>
              </div>
            </div>

            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setShowModal(false)} disabled={isSubmitting}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSubmit} disabled={isSubmitting}>
                  <Icon name="check" size={15} /> {isSubmitting ? 'Saving…' : (editingVersion ? 'Update version' : 'Create version')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* VIEW MODAL */}
      {viewingVersion && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-form-modal" style={{ maxWidth: 720 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="tag" size={22} /></span>
                <div>
                  <h3>v{safeStr(viewingVersion.version)}</h3>
                  <p>{safeStr(viewingVersion.description)}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>

            <div className="prm-form-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <div className="pbo-mini-stats">
                <div><span>App</span><b><AppPill value={viewingVersion.appType} /></b></div>
                <div><span>Version</span><b>v{safeStr(viewingVersion.version)}</b></div>
                <div><span>Platform</span><b>{getPlatformLabel(viewingVersion.platform)}</b></div>
                <div><span>Release Type</span><b><ReleasePill value={viewingVersion.releaseType} /></b></div>
                <div><span>Release Date</span><b>{viewingVersion.releaseDate ? new Date(viewingVersion.releaseDate).toLocaleDateString() : 'N/A'}</b></div>
                <div><span>Status</span><b><StatusPill value={viewingVersion.isActive} /></b></div>
                <div><span>Mandatory</span><b className={viewingVersion.isMandatory ? 'cr-off' : 'cr-ok'}>{viewingVersion.isMandatory ? 'Yes' : 'No'}</b></div>
                <div><span>Latest</span><b className={viewingVersion.isLatest ? 'cr-ok' : ''}>{viewingVersion.isLatest ? 'Yes' : 'No'}</b></div>
                {viewingVersion.size && (
                  <div><span>Size</span><b>{viewingVersion.size} MB</b></div>
                )}
              </div>

              {viewingVersion.releaseNotes && (
                <>
                  <div className="prm-section-title">Release Notes</div>
                  <p style={{ margin: 0, color: '#4a5568' }}>{viewingVersion.releaseNotes}</p>
                </>
              )}

              {safeArr(viewingVersion.features).length > 0 && (
                <>
                  <div className="prm-section-title">Features</div>
                  <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {viewingVersion.features.map((f, i) => <li key={i}>{f}</li>)}
                  </ul>
                </>
              )}

              {safeArr(viewingVersion.bugFixes).length > 0 && (
                <>
                  <div className="prm-section-title">Bug Fixes</div>
                  <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {viewingVersion.bugFixes.map((f, i) => <li key={i}>{f}</li>)}
                  </ul>
                </>
              )}

              {safeArr(viewingVersion.improvements).length > 0 && (
                <>
                  <div className="prm-section-title">Improvements</div>
                  <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {viewingVersion.improvements.map((f, i) => <li key={i}>{f}</li>)}
                  </ul>
                </>
              )}

              {(viewingVersion.downloadUrls?.ios || viewingVersion.downloadUrls?.android || viewingVersion.downloadUrls?.web) && (
                <>
                  <div className="prm-section-title">Download URLs</div>
                  <div className="prm-chips" style={{ flexWrap: 'wrap' }}>
                    {viewingVersion.downloadUrls?.ios && (
                      <a className="prm-chip" href={viewingVersion.downloadUrls.ios} target="_blank" rel="noopener noreferrer">
                        <Icon name="download" size={12} /> iOS
                      </a>
                    )}
                    {viewingVersion.downloadUrls?.android && (
                      <a className="prm-chip" href={viewingVersion.downloadUrls.android} target="_blank" rel="noopener noreferrer">
                        <Icon name="download" size={12} /> Android
                      </a>
                    )}
                    {viewingVersion.downloadUrls?.web && (
                      <a className="prm-chip" href={viewingVersion.downloadUrls.web} target="_blank" rel="noopener noreferrer">
                        <Icon name="download" size={12} /> Web
                      </a>
                    )}
                  </div>
                </>
              )}
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => { const v = viewingVersion; closeViewModal(); handleOpenEdit(v); }}>
                  <Icon name="edit" size={15} /> Edit
                </button>
                <button className="prm-btn primary" onClick={closeViewModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VersionManagement;